<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

export default Vue.extend({
    components: {
        AgGridVue,
    },
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            assignmentHistoryColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.id
                    },
                },
                {
                    field: 'message',
                    headerName: 'Message',
                    sortable: true,
                    valueSetter: (params) => {},
                    valueGetter: (params) => {
                        return params.data.message
                    },
                },
                {
                    field: 'time_added',
                    headerName: 'Time',
                    sortable: true,
                    valueSetter: (params) => {},
                    valueGetter: (params) => {
                        return params.data.time_added
                    },
                },
            ],
        }
    },
    methods: {
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
        },
    },
})
</script>

<template>
    <div>
        <h4>Shows Assignment History Grid</h4>
        <ag-grid-vue class="ag-theme-balham default-grid" :column-defs="assignmentHistoryColumnDefs" :row-data="rowData" @grid-ready="onGridReady" />
    </div>
</template>

<style>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
